"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleStats = void 0;
const react_1 = __importDefault(require("react"));
const ExampleStats = (props) => {
    return (react_1.default.createElement("div", null,
        "Found ",
        props.resultStats.numberOfResults,
        " products"));
};
exports.ExampleStats = ExampleStats;
//# sourceMappingURL=ExampleStats.js.map